import { Component, ErrorInfo, ReactNode } from 'react'
import { captureException } from '@sentry/react'
import { Page500 } from '@monthio/react-components'

export class ChunkLoadErrorBoundary extends Component<
	{ children: ReactNode; moduleFlag: string },
	{ hasError: boolean }
> {
	constructor(props: { children: ReactNode; moduleFlag: string }) {
		super(props)

		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		const isChunkLoadError =
			error.name === 'ChunkLoadError' ||
			error.message.includes('Loading chunk') ||
			error.message.includes('Failed to fetch dynamically imported module') ||
			error.message.includes("Unexpected token '<'")

		if (isChunkLoadError) {
			captureException(error, {
				tags: {
					errorType: 'ChunkLoadError',
					moduleFlag: this.props.moduleFlag,
				},

				extra: {
					errorInfo,
					currentUrl: window.location.href,
					errorMessage: error.message,
					errorStack: error.stack,
				},
			})

			console.error(
				'Chunk loading error for module:',
				this.props.moduleFlag,
				'URL:',
				window.location.href,
				'Error:',
				error,
			)
		} else {
			captureException(error, {
				tags: {
					moduleFlag: this.props.moduleFlag,
				},
				extra: {
					errorInfo,
				},
			})
		}
	}

	public override render() {
		if (this.state.hasError) {
			return <Page500 />
		}

		return this.props.children
	}
}
